import {Record, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';
import {MenuItemRecord, MenuItemType} from './types';

export interface MainNavigationStateProps {
    readonly menuItems: List<MenuItemRecord>;
    readonly default: MenuItemRecord;
    readonly updating: boolean;
    readonly focusMode: boolean;
    readonly behaviors: BehaviorsCollection;
    readonly collapsed: boolean;
}

export class MainNavigationState extends Record<MainNavigationStateProps>({
    menuItems: List(),
    default: new MenuItemRecord(),
    updating: false,
    focusMode: false,
    behaviors: new BehaviorsCollection([]),
    collapsed: false,
}) {}

const buildLink = (type: MenuItemType, id?: string) => {
    switch (type) {
        case MenuItemType.Organization:
            return id ? `/account/organization/${id}` : undefined;
        default:
            return undefined;
    }
};

const linkDescriptionToLink = (linkDescriptionObj: any) => {
    return buildLink(linkDescriptionObj.type, linkDescriptionObj.id) ?? linkDescriptionObj.link;
};

const convertAPIDataToMenuItemRecord = (menuItem: any): MenuItemRecord => {
    const {items, ...otherMenuItemProps} = menuItem;
    return new MenuItemRecord({
        ...otherMenuItemProps,
        link: linkDescriptionToLink(otherMenuItemProps),
        items: items ? List(items.map(convertAPIDataToMenuItemRecord)) : List([]),
    });
};

export default makeReducer<MainNavigationState>(
    [
        match(Actions.focusMode, (state, action) => {
            return state.merge({
                focusMode: action.payload.focus,
            });
        }),
        match(Actions.fetchMenu, state => {
            return state.merge({
                updating: true,
            });
        }),
        match(Actions.fetchMenuFailed, state => {
            return state.merge({
                updating: false,
            });
        }),
        match(Actions.fetchMenuSuccess, (state, {payload}) => {
            const menuItemsData = payload.menuItems;
            const menuItems = List(menuItemsData.items).map(convertAPIDataToMenuItemRecord);
            return state.merge({
                updating: false,
                menuItems,
                default: convertAPIDataToMenuItemRecord(menuItemsData.default),
                behaviors: new BehaviorsCollection(menuItemsData.behaviors),
            });
        }),
        match(Actions.toggleMainNavigation, (state, {payload}) => {
            return state.merge({
                collapsed: payload.collapsed,
            });
        }),
        match(Actions.updateInstitutionTitle, (state, {payload}) => {
            return state.merge({
                menuItems: state.menuItems.map(menuItem => {
                    if (menuItem.type === MenuItemType.Institution && menuItem.id === payload.institutionId) {
                        return menuItem.merge({
                            title: payload.institutionName,
                        });
                    }
                    return menuItem;
                }),
            });
        }),
    ],
    new MainNavigationState(),
);
